<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #beforeBtn>
        <!-- 复合日期搜索框 -->
        <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
          @onChange="onComSearchChange">
        </CompositeFormDate>
        <!-- 复合搜索框 -->
        <CompositeFormCtrl ref="comFormCtrl" :options="searchKeyOptions" @onChange="onComSearchChange">
        </CompositeFormCtrl>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" >
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "MakeupList",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'order',
      getListUrl: 'recycle',
      breadcrumb: [
        { name: "运单管理" },
        { name: "运单回收站" },
      ],
      formCtrl: [],
      curSearchKey: 'shname',
      curSearchValue: undefined,
      searchDateOptions: [
        { label: "装货日期", keyName: "predict_loading_date", },
        { label: "卸货日期", keyName: "predict_unloading_date", },
      ],
      searchKeyOptions: [
        { label: '车牌号', value: 'license', },
        { label: '运单编号', value: 'order_num', },
        { label: '客户名称', value: 'shname', },
      ],
      cols: [
        { prop: "order_num", label: "运单编号", minwidth: 120 },
        { prop: "license", label: "车牌号", minwidth: 110 },
        { prop: "driver", label: "司机姓名", minwidth: 110 },
        { prop: "name", label: "货物名称", minwidth: 120 },
        { prop: "shname", label: "客户名称", minwidth: 160 },
        { prop: "coaddress", label: "装货地址", minwidth: 160 },
        { prop: "enaddress", label: "卸货地址", minwidth: 160 },
        { ...this.ctrls.ZhuangHuoRiQi, minwidth: 120 },
        { ...this.ctrls.XieHuoRiQi, minwidth: 120 },
        { prop: "del_name", label: "删除人", width: 110 },
        { prop: "del_desc", label: "删除原因", width: 110 },
        { prop: "del_time", label: "删除时间", width: 110 },
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/order/recycleview?id=${id}&mode=view`
            );
          },
        },
        {
          ...this.feeBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/order/recyclefee?id=${id}&mode=view`
            );
          },
        },
      ],
    };
  },
  methods: {},
  mounted() { },
};
</script>

<style lang="less" scoped></style>
